import { Link } from "react-router-dom";
import { categories } from "@/mocks/films";

export default function SiteFooter() {
  return (
    <footer className="mt-20 w-full border-t border-background-300 bg-background-100">
      <div className="w-full px-4 py-12 md:px-8 lg:px-12 lg:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:pr-8">
            <div className="flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-background-50">
                <i className="ri-film-line text-lg" />
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">三级片</span>
            </div>
            <p className="mt-4 max-w-xs font-body text-sm leading-relaxed text-foreground-600">
              一个专注三级片影片资料与剧情介绍的影视索引站，帮助影迷按年代、类型与创作者线索快速找到想看的作品。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              <span className="rounded-full border border-background-300 px-2.5 py-1 font-label text-[11px] text-foreground-600">
                虚构示例数据
              </span>
              <span className="rounded-full border border-accent-500/40 px-2.5 py-1 font-label text-[11px] text-accent-500">
                仅限 18 岁以上
              </span>
            </div>
          </div>

          <div>
            <h4 className="font-label text-xs uppercase tracking-[0.22em] text-foreground-500">站内导航</h4>
            <ul className="mt-4 space-y-2.5">
              <li>
                <Link to="/" className="font-body text-sm text-foreground-700 transition-colors hover:text-accent-500">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category" className="font-body text-sm text-foreground-700 transition-colors hover:text-accent-500">
                  全部分类
                </Link>
              </li>
              <li>
                <Link to="/search" className="font-body text-sm text-foreground-700 transition-colors hover:text-accent-500">
                  搜索影片
                </Link>
              </li>
              <li>
                <Link to="/about" className="font-body text-sm text-foreground-700 transition-colors hover:text-accent-500">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-label text-xs uppercase tracking-[0.22em] text-foreground-500">热门分类</h4>
            <ul className="mt-4 space-y-2.5">
              {categories.map((category) => (
                <li key={category.key}>
                  <Link
                    to={`/category?type=${category.key}`}
                    className="font-body text-sm text-foreground-700 transition-colors hover:text-accent-500"
                  >
                    {category.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-label text-xs uppercase tracking-[0.22em] text-foreground-500">内容声明</h4>
            <p className="mt-4 font-body text-sm leading-relaxed text-foreground-600">
              本站不提供影片在线播放、下载或任何付费服务，所有片名、剧情、演职人员均为虚构示例，用于界面与交互演示。
            </p>
            <p className="mt-3 font-body text-sm leading-relaxed text-foreground-600">
              如需反馈内容问题，可前往
              <Link to="/about" className="mx-1 text-accent-500 hover:underline">
                意见反馈
              </Link>
              页面提交。
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-300 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-label text-xs text-foreground-500">
            © {new Date().getFullYear()} 三级片影视大全 · 影视资料演示站点
          </p>
          <div className="flex flex-wrap items-center gap-4">
            <span className="font-label text-xs text-foreground-500">内容均为虚构示例</span>
            <span className="font-label text-xs text-foreground-500">无播放 / 下载功能</span>
          </div>
        </div>
      </div>
    </footer>
  );
}